import Axios from 'axios'
import dayjs from 'dayjs'

export const axios = Axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
})

export const sleep = (ms: number) => new Promise(r => setTimeout(r, ms))

export const formatDate = (date: string) => dayjs(date).format('MMM DD, YYYY')